import script from "./UploadFileList.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadFileList.vue?vue&type=script&setup=true&lang=js"

import "./UploadFileList.vue?vue&type=style&index=0&id=f72ec388&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f72ec388"]])

export default __exports__